import 'openedInvoiceService'
import openedInvoiceModule from './openedInvoiceModule'
import modalSynInvoicCtrl from './modalSynInvoicCtrl'
import openedInvmodalUploadCtrl from './openedInvmodalUploadCtrl'
import modalSurePrint from './modalSurePrint'
import modalSureRed from './modalSureRed'
import modalSureSend from './modalSureSend'
import modalBatchRed from './modalBatchRed'
import openedInvoicePage from './view/openedInvoice.html'
import {
  ovatBill,
  vehicleInvoice,
  openedInvoice,
  invoice,
  rollTypeInvoice,
} from 'redevConfig'
const vehiceAdd = (vehicleInvoice && vehicleInvoice.add) || ''
const invoiceEdit = (invoice && invoice.add) || ''
const list = (openedInvoice && openedInvoice.list) || ''
const detail = (openedInvoice && openedInvoice.detail) || ''
const relatedBill = (openedInvoice && openedInvoice.relatedBill) || ''
const rollDetail = (openedInvoice && openedInvoice.rollDetail) || ''
const addRoll = (rollTypeInvoice && rollTypeInvoice.add) || ''
const checkBillDetail = (ovatBill && ovatBill.checkBillDetail) || ''

const openedInvoiceListPage = list
  ? require(`redevelopment/outputManage/openedInvoice/${list.templateName}`)
  : require('./view/openedInvoiceList.html')
const openedInvoiceListCtrl = list
  ? require(`redevelopment/outputManage/openedInvoice/${list.controllerName}`)
  : require('./openedInvoiceListCtrl')
const openedInvoiceDetailPage = detail
  ? require(`redevelopment/outputManage/openedInvoice/${detail.templateName}`)
  : require('./view/openedInvoiceDetail.html')
const openedInvoiceDetailCtrl = detail
  ? require(`redevelopment/outputManage/openedInvoice/${detail.controllerName}`)
  : require('./openedInvoiceDetailCtrl')
const vehicleDetailPage = vehiceAdd
  ? require(`redevelopment/outputManage/vehicleInvoice/${vehiceAdd.templateName}`)
  : require('app/outputManage/fillOpenManage/vehicleInvoice/view/add.html')
const vehicleDetailCtrl = vehiceAdd
  ? require(`redevelopment/outputManage/vehicleInvoice/${vehiceAdd.controllerName}`)
  : require('../../fillOpenManage/vehicleInvoice/add')
const invoiceEditPage = invoiceEdit
  ? require(`redevelopment/outputManage/invoice/${invoiceEdit.templateName}`)
  : require('../../fillOpenManage/invoice1/view/invoiceEdit.html')
const invoiceEditCtrl = invoiceEdit
  ? require(`redevelopment/outputManage/invoice/${invoiceEdit.controllerName}`)
  : require('../../fillOpenManage/invoice1/InvoiceEditCtrl')
const openedRelatedBillCtrl = relatedBill
  ? require(`redevelopment/outputManage/openedInvoice/${relatedBill.controllerName}`)
  : require('./openedRelatedBillCtrl')
const relatedBillInvoice = relatedBill
  ? require(`redevelopment/outputManage/openedInvoice/${relatedBill.templateName}`)
  : require('./view/relatedBill_invoice.html')
const rollDetailCtrl = rollDetail
  ? require(`redevelopment/outputManage/openedInvoice/${rollDetail.controllerName}`)
  : require('./rollDetailCtrl')
const rollDetailPage = rollDetail
  ? require(`redevelopment/outputManage/openedInvoice/${rollDetail.templateName}`)
  : require('./view/rollTypeInvoice.html')
const addRollCtrl = addRoll
  ? require(`redevelopment/outputManage/rollTypeInvoice/${addRoll.controllerName}`)
  : require('../../fillOpenManage/rollTypeInvoice/add')
const addRollPage = addRoll
  ? require(`redevelopment/outputManage/rollTypeInvoice/${addRoll.templateName}`)
  : require('../../fillOpenManage/rollTypeInvoice/view/add.html')
const checkBillDetailCtrl = checkBillDetail
  ? require(`redevelopment/outputManage/ovatBill/${checkBillDetail.templateName}`)
  : require('../../fillOpenManage/ovatBill/view/checkBillDetailCtrl.html')

export default openedInvoiceModule
  .config(['$stateProvider', routerConf])
  .controller('openedInvoiceListCtrl', openedInvoiceListCtrl.default)
  .controller('openedInvoiceDetailCtrl', openedInvoiceDetailCtrl.default)
  .controller('modalSynInvoicCtrl', modalSynInvoicCtrl)
  .controller('modalSurePrint', modalSurePrint)
  .controller('modalSureRed', modalSureRed)
  .controller('modalSureSend', modalSureSend)
  .controller('openedRelatedBillCtrl', openedRelatedBillCtrl.default)
  .controller('vehicleDetailCtrl', vehicleDetailCtrl.default)
  .controller('rollDetailCtrl', rollDetailCtrl.default)
  .controller('modalBatchRed', modalBatchRed)
  .controller('openedInvmodalUploadCtrl', openedInvmodalUploadCtrl)
  .controller('invoiceEditCtrl', invoiceEditCtrl.default)
  .controller('addRollCtrl', addRollCtrl.default).name

function routerConf($stateProvider) {
  // 'ngInject';
  $stateProvider
    .state('outputManage.billManage.openedInvoice', {
      url: '/openedInvoice',
      template: openedInvoicePage,
      abstract: true,
      title: '已开具发票',
      default: 'outputManage.billManage.openedInvoice.list',
    })
    .state('outputManage.billManage.openedInvoice.list', {
      url: '/list',
      template: openedInvoiceListPage,
      controller: 'openedInvoiceListCtrl',
    })
    .state('outputManage.billManage.openedInvoice.detail', {
      url: '/detail/:invoiceId',
      title: '发票详情',
      template: openedInvoiceDetailPage,
      controller: 'openedInvoiceDetailCtrl',
    })
    .state('outputManage.billManage.openedInvoice.relatedBill', {
      url: '/relatedBill/:waitId',
      template: relatedBillInvoice,
      controller: 'openedRelatedBillCtrl',
      title: '关联销售单',
    })
    .state('outputManage.billManage.openedInvoice.checkBillDetail', {
      url: '/checkBillDetail/:billId',
      template: checkBillDetailCtrl,
      controller: 'checkBillDetailCtrl',
      title: '销售单明细',
    })
    .state('outputManage.billManage.openedInvoice.vehicleDetail', {
      url: '/vehicleDetail/:invoiceId',
      title: '发票详情',
      template: vehicleDetailPage,
      controller: 'vehicleDetailCtrl',
    })
    .state('outputManage.billManage.openedInvoice.rollDetail', {
      url: '/rollDetail/:invoiceId',
      title: '发票详情',
      template: rollDetailPage,
      controller: 'rollDetailCtrl',
    })
    .state('outputManage.billManage.openedInvoice.redInfoInv', {
      url: '/redInfoInv/:waitId/:parentInvoiceId',
      title: '新增红字发票',
      template: invoiceEditPage,
      controller: 'invoiceEditCtrl',
    })
    .state('outputManage.billManage.openedInvoice.redInfoRoll', {
      url: '/redInfoRoll/:waitId/:parentInvoiceId',
      title: '新增红字卷票',
      template: addRollPage,
      controller: 'addRollCtrl',
    })
    .state('outputManage.billManage.openedInvoice.redInfoVehicle', {
      url: '/redInfoVehicle/:waitId/:parentInvoiceId',
      title: '新增红字机动车票',
      template: vehicleDetailPage,
      controller: 'vehicleDetailCtrl',
    })
}



// WEBPACK FOOTER //
// ./src/app/outputManage/billManage/openedInvoice/index.js